import React from 'react';
import { CheckIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal, Eyebrow } from './Section';
import { IMAGES } from './constants';
const includes = ['Acceso inmediato', 'Descarga digital', 'Todos los bonos incluidos'];
export function Offer() {
  return <section id="oferta" className="w-full bg-cream py-16 sm:py-24" data-id="element-111" data-mp="1hoxt7f80oxqj">
      <div className="mx-auto max-w-5xl px-5 sm:px-6" data-id="element-112" data-mp="ty1wq4sm9ecy">
        <Reveal data-id="element-113" data-mp="u0od8txhj47b">
          <div className="overflow-hidden rounded-[2rem] border border-sand bg-white shadow-soft" data-id="element-114" data-mp="p00bbd7px2yb">
            <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-115" data-mp="13wrfdzsc72u9">
              <div className="relative flex items-center justify-center bg-sand/60 p-8 sm:p-10" data-id="element-116" data-mp="13ycabqikcnsn">
                <div className="absolute left-5 top-5 z-10 rounded-full bg-coral px-3 py-1 text-xs font-bold uppercase tracking-wide text-white shadow-card" data-id="element-117" data-mp="ywmwk33yhw0v">
                  50% OFF
                </div>
                <img src={IMAGES.ebook} alt="Portada del ebook Tus primeros USD 1.000 con contenido UGC" className="aspect-[4/5] w-full max-w-xs rounded-2xl object-cover shadow-card" data-id="element-118" data-mp="2af7imm4snprp" />
              </div>

              <div className="p-8 sm:p-10" data-id="element-119" data-mp="zjpufmmq9eu4">
                <Eyebrow data-id="element-120" data-mp="13k00t0efm79i">Oferta de lanzamiento</Eyebrow>
                <h2 className="mt-3 font-display text-2xl font-semibold leading-tight text-plum sm:text-3xl" data-id="element-121" data-mp="13jgkfo4fjqxl">
                  Tus primeros USD 1.000 con contenido UGC
                </h2>

                <div className="mt-6 flex items-end gap-3" data-id="element-122" data-mp="btlw9usb67ai">
                  <span className="font-display text-5xl font-bold text-coral" data-id="element-123" data-mp="funvibm86jch">$599</span>
                  <span className="pb-1 text-lg font-semibold text-ink/60" data-id="element-124" data-mp="kl49pxxve8zw">UYU</span>
                  <span className="pb-2 text-lg text-ink/40 line-through" data-id="element-125" data-mp="kmywziwm6d75">1200 UYU</span>
                </div>
                <p className="mt-1 text-sm text-ink/60" data-id="element-126" data-mp="3oa7k2xbybdl7">Pago único · Sin suscripciones</p>

                <ul className="mt-6 space-y-2.5" data-id="element-127" data-mp="3o7uupz3v60y4">
                  {includes.map(inc => <li key={inc} className="flex items-center gap-2 text-sm text-ink/80" data-id="element-128" data-mp="vde4yw3jnm1f">
                      <CheckIcon className="h-4 w-4 text-coral" data-id="element-129" data-mp="qejo3zp507jy" />
                      {inc}
                    </li>)}
                </ul>

                <div className="mt-8" data-id="element-130" data-mp="107ie9m0a865o">
                  <CTAButton className="w-full" data-id="element-131" data-mp="108jzukexcb1n">Comprar ahora con 50% OFF</CTAButton>
                </div>

                <div className="mt-5 flex items-center justify-center gap-2 text-xs text-ink/60" data-id="element-132" data-mp="cipoy8e60wk1">
                  <LockIcon className="h-3.5 w-3.5" data-id="element-133" data-mp="7k4pwcangix6" />
                  Pago 100% seguro y encriptado
                </div>

                <div className="mt-4 flex flex-wrap items-center justify-center gap-3 text-ink/50" data-id="element-134" data-mp="hfg50vpyzs5g">
                  <ShieldCheckIcon className="h-5 w-5" data-id="element-135" data-mp="1ww6t69gpbdav" />
                  <CreditCardIcon className="h-5 w-5" data-id="element-136" data-mp="1wyt0q93ldst3" />
                  <span className="rounded-md border border-sand px-2 py-1 text-[10px] font-bold" data-id="element-137" data-mp="1svwbhzjjqyg6">VISA</span>
                  <span className="rounded-md border border-sand px-2 py-1 text-[10px] font-bold" data-id="element-138" data-mp="20dm3fyunug1v">MASTERCARD</span>
                  <span className="rounded-md border border-sand px-2 py-1 text-[10px] font-bold" data-id="element-139" data-mp="25fbj5rstvhwa">PAYPAL</span>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}